"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Accordion = _interopRequireDefault(require("../../molecules/Accordion"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AccordionItem = function AccordionItem(_ref) {
  var item = _ref.item,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    onToggle = _ref.onToggle,
    className = _ref.className,
    legacy = _ref.legacy,
    nested = _ref.nested,
    multiOpen = _ref.multiOpen;
  var icon = item.icon,
    title = item.title,
    content = item.content;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeCategory = _useState2[0],
    setActiveCategory = _useState2[1];
  var handleMultiOpen = function handleMultiOpen() {
    setActiveCategory(function (prev) {
      return !prev;
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    "aria-describedby": "Accordion__item",
    className: "Accordion__item ".concat(active || activeCategory ? 'active' : '', " ").concat(className, " "),
    children: [nested ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      className: "Accordion__item".concat(legacy ? '__legacy' : '', "__button ").concat(active || activeCategory ? 'active' : '', "  ").concat(icon ? 'icon' : 'no-icon'),
      onClick: handleMultiOpen,
      "aria-expanded": active,
      children: [!legacy && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
          size: "utility",
          src: icon
        })
      }), content ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
        children: title
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "topic-counter",
          children: "( ".concat(Object.keys(item).length, " )")
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "Accordion__item__arrow ".concat(active || activeCategory ? 'active' : '')
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: multiOpen ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: "Accordion__item".concat(legacy ? '__legacy' : '', "__button ").concat(active || activeCategory ? 'active' : '', "  ").concat(icon ? 'icon' : 'no-icon'),
        onClick: handleMultiOpen,
        "aria-expanded": active,
        children: [!legacy && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
            size: "utility",
            src: icon
          })
        }), content ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          children: title
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "topic-counter",
            children: "( ".concat(Object.keys(item).length, " )")
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "Accordion__item__arrow ".concat(active || activeCategory ? 'active' : '')
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        className: "Accordion__item".concat(legacy ? '__legacy' : '', "__button ").concat(active || activeCategory ? 'active' : '', "  ").concat(icon ? 'icon' : 'no-icon'),
        onClick: onToggle,
        "aria-expanded": active,
        children: [!legacy && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
            size: "utility",
            src: icon
          })
        }), content ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          children: title
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "topic-counter",
            children: "( ".concat(Object.keys(item).length, " )")
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "Accordion__item__arrow ".concat(active || activeCategory ? 'active' : '')
        })]
      })
    }), content ? /*#__PURE__*/(0, _jsxRuntime.jsx)("article", {
      className: "Accordion__item__subtopic--wrapper ".concat(active || activeCategory ? 'active' : ''),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("article", {
        className: "Accordion__subtopic_button ".concat(icon ? 'icon' : 'no-icon', " "),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("article", {
          className: "Accordion__subtopic_text ".concat(icon ? 'icon' : 'no-icon', " ").concat(!item.subtopic ? 'no-subtopic' : ''),
          children: item.content
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion["default"], {
      nested: true,
      multiOpen: multiOpen,
      items: item.subtopic
    })]
  });
};
var _default = AccordionItem;
exports["default"] = _default;